import styled from 'styled-components';

export const FundDetailSC = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  padding: 40px;
  margin-top: 32px;

  border-radius: 25px;
  background-color: hsla(243, 18%, 20%, 1);
  &.top {
    margin-top: 0px;
  }

  .title {
    margin-bottom: 10px;
  }
`;
